"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSpfMaterial = void 0;
const create_spf_material_1 = require("./create-spf-material");
Object.defineProperty(exports, "createSpfMaterial", { enumerable: true, get: function () { return create_spf_material_1.createSpfMaterial; } });
